/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-25 16:10:48
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-28 16:07:08
 * @FilePath: \hlweb2.0\src\pages\Solution\InfoServices\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:48
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-28 16:02:39
 * @FilePath: \hlweb2.0\src\pages\Solution\Archives\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import "antd/dist/antd.css";
import Top from "../../../components/common/Top";
import Footer from "../../../components/common/Footer";
import FreeTrial from "../../../components/FreeTrial";
import Banner from "../common/Banner";
import { Layout } from "antd";
import actionWays from "../../../redux/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "../../../inphone.scss";
import CoreContent from "./CoreContent";
import Future from "./Future";
import Carousel from "./Carousel";
import ProductExperience from "./ProductExperience";
import Advantage from "../../../components/Advantage";
import Customized from "../common/Customized";
import { adaptation } from "../../../utils/adaptation";
import { withTranslation } from "react-i18next";
import "../common/index.scss";
const { Content } = Layout;

class Guaranteed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      publicList: [],
      projectList: [],
      projectName: "",
    };
  }
  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    adaptation();
  }
  render() {
    const { t } = this.props;
    const solution_infoServices = t("solution_infoServices", {
      returnObjects: true,
    });
    return (
      <Layout>
        <Top />
        {/* <ContactModel /> */}
        <Content id="contentId">
          {/* banner图 start*/}
          <Banner active={1} />
          {/* banner图 end*/}
          {/* 档案工作面临的问题与挑战 start*/}
          <Customized customizedObj={solution_infoServices.infoServices1} />
          {/* 档案工作面临的问题与挑战 end*/}
          {/* 未来 sart*/}
          <Future />
          {/* 未来 end*/}
          {/* 核心内容 start*/}
          <CoreContent />
          {/* 核心内容 end*/}
          {/* 为什么选择我们 start*/}
          <Carousel />
          {/* 为什么选择我们 end*/}

          {/* 四大核心优势  start*/}
          <Advantage
            advantageList={solution_infoServices.infoServices5.contractList}
            advantageName={solution_infoServices.infoServices5}
          />
          <ProductExperience />
          {/* 四大核心优势  end*/}
          <FreeTrial />
          {/* 在线体验 end*/}
          <Footer />
        </Content>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(Guaranteed)));
